import * as React from 'react';
import { MainFormQuestionLayout } from '../../components';
import { useMainFormQuestionHandlers, useMainFormQuestion, useSetOfferLabel } from '../../hooks';
import { EContainerTypes } from '../../types';

export interface IMainFormQuestionContainerProps {
  containerType: EContainerTypes;
}

export const MainFormQuestionContainer: React.FC<IMainFormQuestionContainerProps> = ({ containerType }) => {
  const mainFormQuestion = useMainFormQuestion(containerType);
  const mainFormQuestionHandlers = useMainFormQuestionHandlers(mainFormQuestion);
  const { isLoading, isError, setOfferLabel } = useSetOfferLabel({
    showLabel: true,
    onSuccess: () => mainFormQuestionHandlers.onAnswerYes(),
  });

  const onAnswerYes = () => {
    /**
     * MaternityCapitalQuestion - это последний вопрос в форме,
     * после ответа на него, надо послать запрос на изменение лейбла
     */
    if (containerType === EContainerTypes.MaternityCapitalQuestion) {
      setOfferLabel();
    } else {
      mainFormQuestionHandlers.onAnswerYes();
    }
  };

  return (
    <MainFormQuestionLayout
      {...mainFormQuestion}
      {...mainFormQuestionHandlers}
      isLoading={isLoading}
      isError={isError}
      onAnswerYes={onAnswerYes}
    />
  );
};
